import { useRef, useState } from 'react';

export function use_state_ref<T>(value_initial: T): [T, (value: T) => void, React.MutableRefObject<T>] {
  const [state, set_state] = useState(value_initial);
  const ref = useRef(state);

  function set_state_and_ref(value: T) {
    ref.current = value;
    set_state(value);
  }

  return [state, set_state_and_ref, ref];
}
